import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import s from '../../HoteliersProposeCard.module.scss';
import calendar from 'assets/icons/proposeCard/calendar.svg';
export const Date = ({ dates }) => {
    const { dateFrom, dateTo } = dates;
    return (_jsxs("div", Object.assign({ className: s.booking_wrapper }, { children: [_jsx("img", { className: s.calendar_icon, src: calendar, alt: "calendar" }), _jsxs("div", Object.assign({ className: s.booking__dates }, { children: [dateFrom.toLocaleString('ru', { year: 'numeric', month: 'short', day: 'numeric' }), " -", dateTo.toLocaleString('ru', { year: 'numeric', month: 'short', day: 'numeric' })] }))] })));
};
